<div
  #locationField
  (click)="locationClicked.emit(true)"
  (keydown.enter)="locationClicked.emit(true)"
  (keydown.space)="locationClicked.emit(true)"
  class="flex flex-col pt-[12px] px-[16px] pb-[8px] border border-solid border-stroke-01 rounded-02 bg-white min-w-[200px] w-full h-[74px] cursor-pointer bg-surface-02"
  [ngClass]="{
    'outline-2 outline-stroke-alert !outline': error
  }"
  id="location-field"
  tabindex="0"
  role="button"
>
  <label
    class="font-semibold font-[375px] text-[36px] leading-[36px] font-whitneytracking-[-0.5px] text-center m-0 cursor-pointer whitespace-nowrap overflow-clip text-ellipsis max-w-full text-heading"
    [attr.aria-label]="content.accessibilityLocation + ' ' + content.label"
  >
    {{ content.label }}
  </label>
  <div
    class="text-label-xs-semibold text-center border-none outline-none bg-transparent cursor-pointer"
    [ngClass]="{
      'text-alert': error,
      'text-input-text text-body-copy': !error
    }"
  >
    {{ content.placeholder }}
  </div>
</div>
